var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("template", {
    slot: "header"
  }, [_vm._v("Page 2 header")]), _vm._v(" Hello World ")], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };